import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { Phone, MessageCircle } from 'lucide-react';

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-brand-gray-light">
      <Header />
      
      <main className="flex-grow">
        <Outlet />
      </main>

      <Footer />

      {/* Floating Sticky CTA for Mobile & Desktop */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
        <a 
          href="https://wa.me/4915219576394" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl transition-transform hover:scale-110"
          aria-label="WhatsApp Kontakt"
        >
          <MessageCircle className="w-7 h-7" />
        </a>
        <a 
          href="tel:+4915219576394" 
          className="flex items-center justify-center w-14 h-14 bg-brand-red hover:bg-brand-red-dark text-white rounded-full shadow-2xl transition-transform hover:scale-110"
          aria-label="Notdienst anrufen"
        >
          <Phone className="w-7 h-7" />
        </a>
      </div>
    </div>
  );
}
